import React, { useEffect, useState } from "react";
import DashboardWrapper from "../../../components/DashboardWrapper";
import CrudTable from "../../../components/dashboard/table/CrudTable";

import transactionService from "../../../services/transactionService";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader";
import Breadcrumb from "../../../components/Breadcrumbdashboard";

export default function ReadAllTransaction() {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  // Table columns to show
  const columns = [
    "sl",
    "transaction_id",
    "order_id",
    "payment_method",
      "payment_gateway",
  "utr_number",
  "auth_code",
    "amount",
    "order_invoice",
    "created_at",
  ];

  const fetchTransactions = async () => {
    try {
      const response = await transactionService.getAllTransactions();

    const formatted = response.data.map((t, index) => ({
  sl: index + 1,
  ...t,  
  
  payment_gateway: t.payment_gateway || "N/A",
  utr_number: t.utr_number || "N/A",
  auth_code: t.auth_code || "N/A",

  order_invoice: (t.order?.invoice_id || "N/A").toUpperCase(),

  created_at: new Date(t.created_at).toLocaleString("en-GB", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  }),
}));

      setTransactions(formatted);
    } catch (error) {
      console.error("Error fetching transactions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

  const handleEdit = (row) => navigate(`/admin/order/${row.order_id}`);
  const handleDelete = () => {};

  return (
    <DashboardWrapper>
      <div className="container-fluid mt-4">
       
         <div
        className="d-flex justify-content-between align-items-center"
        style={{
          marginBottom: "8px",
          padding: "0 4px",
        }}
      >
        {/* Page Title - LEFT */}
        <h4
          className="mb-0"
          style={{
            fontSize: "20px",
            fontWeight: "500",
            color: "#374151",
          }}
        >
        All Transactions
        </h4>

        {/* Breadcrumb - RIGHT */}
        <div style={{ margin: 0 }}>
          <Breadcrumb />
        </div>
      </div>
      

        <div className="card shadow">
          <div className="card-header d-flex justify-content-between align-items-center ">
            <h4 className="mb-0"></h4>
          </div>

          <div className="card-body">
            {loading ? (
              <Loader />
            ) : (
              <CrudTable
                data={transactions}
                onEdit={handleEdit}
                onDelete={handleDelete}
                columns={columns}
              />
            )}
          </div>
        </div>
      </div>
    </DashboardWrapper>
  );
}
